import { z } from 'zod';

import { requiredString } from '@/utils/zodUtils';

export const PricingNameFormSchema = (t) =>
  z
    .object({
      name: requiredString(t),
      description: requiredString(t),
    })
    .strict()
    .required();

export type PricingNameFormType = z.infer<ReturnType<typeof PricingNameFormSchema>>;
